export default {
  placeholder: 'Vybrať používateľa',
};
